export const environment = {
    production: false,
    backendUrl: 'https://api.dev.datahub.mk'
};